module.exports = __webpack_public_path__ + "static/media/kv-zh-Hans.70f88ed7.jpg";